import { ResponsiveModal } from '@lt/components';
import { useTranslation } from '@lt/localization';
import React from 'react';
import styles from './orderLoader.module.css';
import Preloader from '../Preloader';

const OrderLoader = () => {
  const { t } = useTranslation();
  return (
    <ResponsiveModal
      center
      onClose={() => null}
      open
      showCloseIcon={false}
      styles={{ modal: { width: 231, height: 180, borderRadius: 6 } }}
    >
      <div className={styles.popupContainer}>
        <Preloader />
        <div className={styles.loaderText}>
          {t('checkout.preloader.message')}
        </div>
      </div>
    </ResponsiveModal>
  );
};

export default OrderLoader;
